import type { VueQueryPluginOptions } from '@tanstack/vue-query'
import {
  MutationCache,
  QueryCache,
  QueryClient,
  VueQueryPlugin,
} from '@tanstack/vue-query'
import { reportApiError } from '@/shared/api/reportApiError'

// Global error reporting — every failed query or mutation flows through
// here, so 5xx / network errors always reach Sentry instead of being
// silently parked in TanStack Query's error state.
const queryCache = new QueryCache({
  onError: (error, query) => {
    reportApiError(error, { source: 'query', key: query.queryKey })
  },
})

const mutationCache = new MutationCache({
  onError: (error, _variables, _context, mutation) => {
    reportApiError(error, {
      source: 'mutation',
      key: mutation.options.mutationKey,
    })
  },
})

const queryClient = new QueryClient({
  queryCache,
  mutationCache,
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      retry: 1,
    },
  },
})

export const vueQueryPluginOptions: VueQueryPluginOptions = {
  queryClient,
}

export { queryClient, VueQueryPlugin }
